import requestFunctions from "../../functions/requestFunctions";


export const state = {
  PRODUCTS_ITEM: {},
  PRODUCTS_LIST: [],
  PRODUCTS_TABLE_DATA: [],
  PRODUCTS_ARRAY_DATA: [],
  PRODUCTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_PRODUCTS_ITEM: (state) => {
    return state.PRODUCTS_ITEM;
  },
  GET_PRODUCTS_LIST: (state) => {
    return state.PRODUCTS_LIST;
  },
  GET_PRODUCTS_TABLE_DATA: (state) => {
    return state.PRODUCTS_TABLE_DATA;
  },
  GET_PRODUCTS_ARRAY_DATA: (state) => {
    return state.PRODUCTS_ARRAY_DATA;
  },
  GET_PRODUCTS_TOTAL_ROWS: (state) => {
    return state.PRODUCTS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_PRODUCTS_ITEM(state, item) {
    state.PRODUCTS_ITEM = item;
  },

  UPDATE_PRODUCTS_LIST(state, list) {
    
    state.PRODUCTS_LIST = list.data;

    state.PRODUCTS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.PRODUCTS_TABLE_DATA = [];
    state.PRODUCTS_ARRAY_DATA = [];

    list.forEach(el => {

      state.PRODUCTS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'brand_name' : el.brand_name,
        'unit_name' : el.unit_name,
        'unit_code' : el.unit_code,
        'buy_cost'   : el.buy_cost,
        'comments'   : el.comments,
        'article_number' : el.article_number,
        'code' : el.code,
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
        'product_category_name': el.product_category_name,
      });

      state.PRODUCTS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_PRODUCTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/products/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PRODUCTS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_PRODUCTS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/products';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_PRODUCTS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_PRODUCTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/products';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PRODUCTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/products/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_PRODUCTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/products/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}